module.exports = __webpack_public_path__ + "img/w64.1008a649.svg";